import { Link, SHADOW_LEVEL1, styled, Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { VFC } from 'react';

import { VipOrderConsultant } from './VipOrderConsultant';
import { VipOrderForm } from './VipOrderForm';
import type { VipAccessData, VipAccessLabels } from '~/models';

const VipOrderRoot = styled('div')(({ theme }) => ({
  background: theme.palette.common.white,
  // TODO(10/05/2022): Remove after new release of ori-ui.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any -- not working theme augmentation
  borderRadius: (theme.shape as any).mediumComponentRadius,
  boxShadow: SHADOW_LEVEL1,
  display: 'flex',
  flexDirection: 'column',
  height: 'fit-content',
  margin: theme.spacing(1),
  padding: theme.spacing(3),
  position: 'absolute',
  right: theme.spacing(10),
  top: '100%',
  width: 400,

  [theme.breakpoints.down('sm')]: {
    right: 0,
    width: 'calc(100% - 40px)',
  },
}));

const VipOrderLink = styled(Link)(({ theme }) => ({
  marginTop: theme.spacing(2),
  textDecoration: 'none',
  WebkitTapHighlightColor: 'transparent',
  width: 'fit-content',
}));

const VipOrderLinkValue = styled(Typography)(({ theme }) => ({
  textDecoration: 'none',

  '&:hover, &:focus, &:active': {
    color: theme.palette.text.disabled,
  },
}));

interface VipOrderProps {
  vipAccessData: VipAccessData;
  vipAccessLabels: VipAccessLabels;
}

export const VipOrder: VFC<VipOrderProps> = ({ vipAccessData, vipAccessLabels }) => {
  const { CustomerOnBehalfOfFormattedName, ConsultantNumber, Links } = vipAccessData;
  const { getTestId } = useTestId();

  return (
    <VipOrderRoot data-testid={getTestId('vip-order-popup')}>
      <Typography variant="h6">{CustomerOnBehalfOfFormattedName}</Typography>
      <Typography variant="body1">{ConsultantNumber}</Typography>
      <VipOrderConsultant
        vipAccessData={vipAccessData}
        vipAccessLabels={vipAccessLabels}
      />
      <VipOrderForm vipAccessLabels={vipAccessLabels} />
      {Links.map((link) => (
        <VipOrderLink
          key={link.Text}
          href={link.Url}
        >
          <VipOrderLinkValue variant="body1">{link.Text}</VipOrderLinkValue>
        </VipOrderLink>
      ))}
    </VipOrderRoot>
  );
};
